import React from 'react'
import './PageComponent.scss'
import PropTypes from 'prop-types'
import joinClassNames from '../../helpers/joinClassNames'

const PageComponent = ({backgroundColor, style, containerStyle, children}) => {
    const colorsMap = {
        lightgray: 'has-lightgray-background',
    }

    const colorClass = colorsMap[backgroundColor] || null

    return (
        <section className={joinClassNames('page__component', colorClass)} style={style}>
            <div className="container" style={containerStyle}>
                {children}
            </div>
        </section>
    )
}

PageComponent.propTypes = {
    backgroundColor: PropTypes.string,
    style: PropTypes.object,
    containerStyle: PropTypes.object,
}

PageComponent.defaultProps = {
    backgroundColor: 'white',
    style: {},
    containerStyle: {},
}

export default PageComponent
